import ChartsSection from "./ChartsSection";
import InputSection from "./InputsSection";
import ResultsSection from "./ResultsSection";
import "./GasRateCritical.css";


const GasRateCriticalCalculator = () => {
	const handlePaste = () => { };

	return (
		<div className="grc__container" onPasteCapture={handlePaste} tabIndex={0}>
			<InputSection />
			<ResultsSection />
			<ChartsSection />
		</div >
	)
}

export default GasRateCriticalCalculator;
